import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Modal, Tooltip, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from "react";
import { useActionData, useFetcher, useLoaderData, useParams, useRevalidator } from 'react-router-dom';
import { Currency, DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
import styles from './quoatation.module.scss';
//import { DatePicker } from "antd";
import { uploadFileFromObject } from "../../../api/common/image-upload";
import { sendCombinedPricesByFile } from "../../../api/vendor/vendorQuotation";
import { ViewAndDownload } from '../../../components/design';
import { Box } from '../../../components/design';
import { ActionError } from '../../../library/classes/exceptions';
import { convertDate } from "../../../library/helpers/dateFormat";
import { Message, MessageTypes, PDFUpload } from "../../../ui";
import style2 from '.././stepBody.module.scss';
import { showAlert } from '../../../components/message/alert.jsx';
const calcTotalPrice = (initialPurchase, initialShipping, quantity) => {
    return (((parseFloat(initialPurchase) * parseInt(quantity)) + parseFloat(initialShipping || 0.00)))
}
const useQuotationLineTotals = (initialPurchase, initialShipping, quantity) => {
    const [purchase, setPurchase] = useState(parseFloat(initialPurchase));
    const [shipping, setShipping] = useState(parseFloat(initialShipping));
    const [total, setTotal] = useState(calcTotalPrice(initialPurchase, initialShipping, quantity));

    useEffect(() => {
        setTotal(calcTotalPrice(purchase, shipping, quantity))
        console.log(total);

    }, [purchase, shipping]);
    return {
        purchase,
        shipping,
        total,
        setPurchase,
        setShipping,
        setTotal: (val) => {
            setPurchase((parseFloat(val)) / quantity)
            setShipping(0)
        }
    };
}

const PriceRow = ({ item, enabled, date, currency }) => {
    const { purchase, shipping, total, setPurchase, setShipping, setTotal } = useQuotationLineTotals(item.price_unit, item.transport_price, item.quantity)
    const userData = JSON.parse(localStorage.getItem('USER'));
    const defaultCurrency = userData.currency.code;
    return (
        <div className={styles.deliveryRow}>
            <div>{item.quantity}</div>
            <div>{date == null ? 'N/A' : convertDate(date)}</div>
            <input type="hidden" name={`[${item.id}]quantity`} value={item.quantity} />
            <div>
                <FieldWrapper>
                    <DatePicker disabledAfter={date} name={`[${item.id}]expected_artwork_received_date`} value={item.expected_artwork_received_date} disabled={!enabled} useHidden />
                </FieldWrapper>
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} required name={`[${item.id}]purchase_price`} value={purchase} onChange={(val) => { setPurchase(val) }} />
                </FieldWrapper>
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} value={shipping} name={`[${item.id}]shipping_cost`} onChange={(val) => { setShipping(val) }} />
                </FieldWrapper>
            </div>
            <div>
                <FieldWrapper>
                    <Currency currency={currency == null ? defaultCurrency : currency?.code} value={total} name={`[${item.id}]total_price`} onChange={val => setTotal(val)} />
                </FieldWrapper>
            </div>
        </div>
    )
}

PriceRow.propTypes = {
    item: PropTypes.object,
    enabled: PropTypes.bool,
    date: PropTypes.string,
    currency: PropTypes.object
}


const NewQuotation = () => {

    const { quoatationData } = useLoaderData()
    const { id } = useParams()
    const actionData = useActionData()
    const infoText = 'When vendor filled Purchase price/piece then Total amount section will be auto calculated and read only. When vendor fills Total price then Per piece and shipping cost will be read only'
    const instructions = "To determine this date: \n\n 1. Know Your Deadlines: This is the date by which you need to have the final artwork in hand, based on the delivery deadline provided by the client. \n\n 2. Calculate Production & Shipment Time: Deduct the total days you require for both production and shipment after receiving approval on the artwork proof.\n\n 3. Set Your Receive Date: The result is the latest date you should receive the final ArtWork to meet the client's delivery deadline."
    const revalidator = useRevalidator()
    const fileUploaderRef = useRef([])
    const [open, setOpen] = useState(false);
    const fetcher = useFetcher()
    const handleFilesUpload = async () => {
        if (fileUploaderRef.current.length === 0) {
            showAlert('Please select atleast one file')
            return
        }
        const promises = fileUploaderRef.current.map(file => uploadFileFromObject(file))
        try {
            const fileIds = await Promise.all(promises)
            const jsonData = { file: fileIds[0], comment: '' }
            const response = await sendCombinedPricesByFile(id, jsonData)
            const { message: msg } = response
            message.success(msg);
            setOpen(false);
            revalidator.revalidate()
        }
        catch (error) {
            throw new Response('Unable to upload files', { status: 500 })
        }
    }

    const handleCancel = () => {
        setOpen(false);
    };
    const showModal = () => {
        setOpen(true);
    };
    return (
        <div>
            <div className={styles.container}>
                {/* <div className={styles.request} onClick={()=>{setCurrent(3)}}>Request for Visual</div> */}
                <h3>Task For You</h3>
                <div>
                    <fetcher.Form method='post'>
                        <input type="hidden" name='itemId' value={quoatationData.vendorData.id} />
                        <Box header={
                            <div className={styles.deliveryRowHead}>
                                <div>Quantity</div>
                                <div> <Tooltip title={'The estimated date for the delivery to be completed.'} >Deadline Delivery Date <InfoCircleOutlined /></Tooltip></div>
                                <div>Artwork Approved Date <Tooltip title={instructions} overlayStyle={{ maxWidth: '500px', whiteSpace: 'pre-line' }} >
                                    <InfoCircleOutlined />
                                </Tooltip></div>
                                <div>Price / Unit <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                                <div>Shipping Cost <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                                <div>Total Amount <Tooltip title={infoText} ><InfoCircleOutlined /> </Tooltip></div>
                            </div>
                        }>
                            {quoatationData.vendorData.item_vendor_quotation_prices.map((value) => {
                                return (
                                    <PriceRow currency={quoatationData.vendorData.currency} item={value} enabled={true} key={value.id} date={quoatationData.item.client_expected_delivery_date} />
                                )
                            })}
                        </Box>
                        <InputWrapper label='Comment for Leopriting' name='comment' placeholder="Your message Here..." allowClear textarea />

                        <div className={styles.bottomButton}>
                            <Button type='primary' ghost onClick={() => { showModal(true) }}> <Tooltip title={'Upload You Own Quotation in PDF format to Leopriting'} >Upload Quotation</Tooltip></Button>
                            <Button type='primary' htmlType='submit' name='action' value='sendQuotation'> <Tooltip title={'Send Quotation to Leoprinting'} >Send Quotation </Tooltip></Button>
                            
                        </div>
                    </fetcher.Form>

                </div>
            </div>
            <br />

            <Modal
                title="Upload Quotation"
                open={open}
                onOk={handleFilesUpload}
                onCancel={handleCancel}
            >
                <div className="wrapper clientartwork-wrapper">
                    <div className="main">
                        <div className={`box--white ${style2.wrapper}`}>
                            <div className={style2.content}>
                                {!!actionData && actionData instanceof ActionError && <Message type={MessageTypes.ERROR} message={actionData.message} timeOut={3} />}
                                {actionData === true && <Message type={MessageTypes.SUCCESS} message="File Uploaded Successfully" timeOut={3} />}
                                <PDFUpload ref={fileUploaderRef} />
                                <i>Supported formats : PDF</i>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {quoatationData.vendorData.file != null &&
                <div className={styles.stepBox}>
                    <div className={styles.message}>
                        <Alert message='File Shared' description={'Your Quotation File has been shared with leoprinting'}
                            action={
                                <ViewAndDownload project_id={quoatationData.item.project_id}
                                    item_id={quoatationData.item.id}
                                    name={quoatationData.vendorData.file.quotation.url}
                                />
                                // ViewAndDownload
                                // ViewAndDownload
                                // <Link to={getFilePath(quoatationData.item.project_id, quoatationData.item.id, quoatationData.vendorData.file.quotation.url)}><Button icon={<FilePdfOutlined />}>View File</Button></Link>
                            }
                        />



                    </div>

                </div>
            }
        </div>
    )
}

export default NewQuotation;
